import { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { useAppSelector } from "store/index";
import { selectIsSidebarOpen } from "store/selectors";

type SidebarOpenContainerProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Owns `selectIsSidebarOpen` so layout parents (and thus Outlet / page content)
 * do not re-render when the left sidebar opens or closes.
 * `data-sidebar-open` is still set on an ancestor for ContentSidebar SCSS.
 */
export const SidebarOpenContainer: FC<SidebarOpenContainerProps> = ({ children, className }) => {
  const isMobile = !useIsMdOrLarger();
  const isSidebarOpen = useAppSelector(selectIsSidebarOpen);

  return (
    <div
      className={twMerge("flex h-1 grow", className)}
      data-sidebar-open={isMobile ? undefined : isSidebarOpen || undefined}
    >
      {children}
    </div>
  );
};
